/**
 * Created by cedricgodefroy on 27/10/2017.
 */
angular.module('FlexyBeautyApp.services').
factory('NumberSeparatorType',[function ()
{
    return {
        DECIMAL: {id: 'decimal'},
        GROUP: {id: 'group'}
    };
}]);
angular.module('FlexyBeautyApp.services')
    .factory('CurrencyManager', ["CurrencyData","LanguageManager","NumberSeparatorType", function (CurrencyData,LanguageManager,NumberSeparatorType) {
        let CurrencyManager = {
            symbol : null,
            code : null,
            codeIso : null,
            intlFormatter : null
        };

        CurrencyManager.setByCurrency = function(currency){
            if(currency !== null) {
                this.set(currency.symbol, currency.code, currency.codeMango);
            }
            else{
                this.setDefaultCurency();
            }
            this.setIntlFormatter();
        };

        CurrencyManager.set = function(symbol, code, codeIso){
            if(symbol && code && codeIso) {
                this.symbol = symbol;
                this.code = code;
                this.codeIso = codeIso;
            }
            else{
                this.setDefaultCurency();
            }
            this.setIntlFormatter();
        };

        CurrencyManager.setDefaultCurency = function(){
            this.symbol = "€";
            this.code = "eu";
            this.codeIso = "EUR";
        };

        CurrencyManager.getCurrencyCode = function(){
            return this.code;
        };

        CurrencyManager.getCurrencySymbol = function(){
            return this.symbol;
        };

        CurrencyManager.getCurrencyCodeIso = function(){
            return this.codeIso;
        };

        CurrencyManager.isEuroCurrency = function(){
            return this.codeIso === "EUR";
        };

        CurrencyManager.getSeparator =  function(separatorType) {
            const numberWithGroupAndDecimalSeparator = 1000.1;
            let separator,
                intlFormater = LanguageManager.getIntlNumberFormatter();

            if(intlFormater) {
                separator = intlFormater
                    .formatToParts(numberWithGroupAndDecimalSeparator)
                    .find(part => part.type === separatorType.id)
                    .value;
            }
            else {
                if (separatorType === NumberSeparatorType.GROUP) {
                    separator = numberWithGroupAndDecimalSeparator
                        .toLocaleString(LanguageManager.getLocale())
                        .substring(1, 2);
                }
                else if (separatorType === NumberSeparatorType.DECIMAL) {
                    separator = numberWithGroupAndDecimalSeparator
                        .toLocaleString(LanguageManager.getLocale())
                        .substring(5, 6);
                }
            }
            return separator;
        };

        CurrencyManager.setIntlFormatter = function(){
            try {
                if (Intl && typeof Intl === 'object' && Intl && Intl.NumberFormat && typeof Intl.NumberFormat === 'function' && Intl.NumberFormat.prototype.hasOwnProperty("formatToParts") && Intl.NumberFormat.prototype.hasOwnProperty("format")) {
                    this.intlFormatter = new Intl.NumberFormat(LanguageManager.getLocale(), {
                        style: 'currency',
                        currency: this.getCurrencyCodeIso(),
                        minimumFractionDigits: 2,
                        // the default value for minimumFractionDigits depends on the currency
                        // and is usually already 2
                    });
                }
            }
            catch(e){
                //sometimes some browsers (mobile safari) throw an exception " ReferenceError · Can't find variable: Intl" despite of the test above
                //if it occurs an exception with Intl, we force the intlNumberFormatter to null in order to format the number with the "old method"
                this.intlFormatter = null;
            }
        };

        CurrencyManager.getIntlFormatter = function(){
            return this.intlFormatter;
        };

        CurrencyManager.getPriceFromPriceInput = function(priceInput){
            return priceInput
                .replace(/\s/g, '')
                .replace(this.getCurrencySymbol(), "")
                //systematical echapment of all group separator
                //In the world there are only 4 group separators : , .’˙ (http://www.statisticalconsultants.co.nz/blog/how-the-world-separates-its-digits.html)
                //this action is usefull and possible because of two reasons :
                //1) the . character have a particular role in a Regexp expression so we have to escape it
                //2) the expression with the other group separator and the escape character (\, \’ and \˙) have no particular role in Regexp (not like \d or other \s) so that the escape character is transparent and not radically change the meaning of the Regexp
                .replace(new RegExp("\\" + this.getSeparator(NumberSeparatorType.GROUP), "g"), "")
                .replace(this.getSeparator(NumberSeparatorType.DECIMAL), ".");
        };

        return CurrencyManager;
    }]);


// WEBPACK FOOTER //
// ./js/services/tools/CurrencyManager.js